const curEnv = process.env.NODE_ENV;
const testVersion = '5.8.0.9';
const prodVersion = '3.2.5';
const version = curEnv === 'development' ? testVersion : prodVersion;
console.log('测试环境版本', version); // 测试环境添加版本号打印，便于查看代码更新
export { version };
